import { render, staticRenderFns } from "./SettingsUserEditRolesAndPermissionsView.vue?vue&type=template&id=3078010a&scoped=true&"
import script from "./SettingsUserEditRolesAndPermissionsView.vue?vue&type=script&lang=js&"
export * from "./SettingsUserEditRolesAndPermissionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3078010a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3078010a')) {
      api.createRecord('3078010a', component.options)
    } else {
      api.reload('3078010a', component.options)
    }
    module.hot.accept("./SettingsUserEditRolesAndPermissionsView.vue?vue&type=template&id=3078010a&scoped=true&", function () {
      api.rerender('3078010a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/users/edit/SettingsUserEditRolesAndPermissionsView.vue"
export default component.exports